import React, { useRef, useLayoutEffect, useState } from 'react';
import { useIsMounted } from '@hooks/useIsMounted';
import { useScrollController } from '@context/ScrollControllerProvider/useScrollController';
import ScrollMagic from 'scrollmagic';
import { Box } from '@components/Box';
import {
  AvatarBoxPositionWrapper,
  AvatarContainer,
  AvtarFront,
  AvtarFrontText,
  AvatarBack,
  AvatarBackImage,
  AvatarWrap,
  OuterBorder,
  PlusOneAttendeeWrap,
  PlusOneNamesImage,
} from './PlusOnes.styles';

const PlusOneAttendeeAvatar = [
  {
    alt: 'Avatar Image',
    resBottom: '14%',
    resRight: '-50%',

    content: '+1',
    resHeight: '101px',
    borderResHeight: '108px',
    src: 'common/avatars/avatars_photo_avatar-1.jpg',
    sizeVariant: '240px',
    bottom: '0%',
    right: '15%',
    height: '240px',
    width: '240px',

    borderHeight: '272px',
    borderWidth: '272px',
  },
  {
    alt: 'Avatar Image',
    resBottom: '47%',
    resLeft: '-55%',

    content: '+1',
    resHeight: '120px',
    borderResHeight: '127px',
    src: 'common/avatars/avatars_photo_avatar-2.jpg',
    sizeVariant: '180px',
    bottom: '42%',
    left: '-4%',
    height: '180px',
    width: '180px',

    borderHeight: '212px',
    borderWidth: '212px',
  },
  {
    alt: 'Avatar Image',
    resBottom: '20%',
    resLeft: '-16%',

    content: '+1',
    resHeight: '121px',
    borderResHeight: '128px',
    src: 'common/avatars/avatars_photo_avatar-3.jpg',
    sizeVariant: '292px',
    bottom: '2%',
    left: '7%',
    height: '292px',
    width: '292px',

    borderHeight: '324px',
    borderWidth: '324px',
  },
  {
    alt: 'Avatar Image',
    resBottom: '21%',
    resRight: '-10%',

    content: '+1',
    resHeight: '120px',
    borderResHeight: '127px',
    src: 'common/avatars/avatars_photo_avatar-4.jpg',
    sizeVariant: '180px',
    bottom: '27%',
    right: '-2%',
    height: '180px',
    width: '180px',

    borderHeight: '212px',
    borderWidth: '212px',
  },
  {
    alt: 'Avatar Image',
    resBottom: '32%',
    resLeft: '36%',

    content: '+1',
    resHeight: '137px',
    borderResHeight: '144px',
    src: 'common/avatars/avatars_photo_avatar-5.jpg',
    sizeVariant: '330px',
    bottom: '25%',
    left: '36%',
    height: '330px',
    width: '330px',

    borderHeight: '362px',
    borderWidth: '362px',
  },
  {
    alt: 'Avatar Image',
    resBottom: '50%',
    resLeft: '0%',

    content: '+1',
    resHeight: '100px',
    borderResHeight: '107px',
    src: 'common/avatars/avatars_photo_avatar-6.jpg',
    sizeVariant: '240px',
    bottom: '59%',
    left: '17%',
    height: '240px',
    width: '240px',

    borderHeight: '272px',
    borderWidth: '272px',
  },
  {
    alt: 'Avatar Image',
    resBottom: '50%',
    resRight: '-10%',

    content: '+1',
    resHeight: '121px',
    borderResHeight: '128px',
    src: 'common/avatars/avatars_photo_avatar-7.jpg',
    sizeVariant: '292px',
    bottom: '54%',
    right: '6%',
    height: '292px',
    width: '292px',

    borderHeight: '324px',
    borderWidth: '324px',
  },
];

export const PlusOneAttendee: React.FC<{}> = () => {
  const [active, setActive] = useState<Array<number>>([]);
  const plusOneContainerRef = useRef<HTMLDivElement>(null);
  const scrollController = useScrollController();
  const isMounted = useIsMounted();

  useLayoutEffect(() => {
    let scene: InstanceType<typeof ScrollMagic.Scene> | undefined;

    if (scrollController && isMounted && plusOneContainerRef) {
      const startScrollAnimation = () => {
        scene = new ScrollMagic.Scene({
          triggerElement: '#PlusOnes',
          triggerHook: 'onCenter',
          duration: '60%',
          offset: 120,
        })
          .addTo(scrollController)
          .on('progress', (event: ScrollMagic.SceneProgressEvent) => {
            let eventProgress = event.progress * 100;
            if (eventProgress >= 1 && eventProgress < 10) {
              setActive([2]);
            } else if (eventProgress >= 15 && eventProgress < 25) {
              setActive([2, 3]);
            } else if (eventProgress >= 30 && eventProgress < 40) {
              setActive([2, 3, 6]);
            } else if (eventProgress >= 45 && eventProgress < 55) {
              setActive([2, 3, 6, 5]);
            } else if (eventProgress >= 60 && eventProgress < 70) {
              setActive([2, 3, 6, 5, 7]);
            } else if (eventProgress >= 75 && eventProgress < 85) {
              setActive([2, 3, 6, 5, 7, 1]);
            } else if (eventProgress >= 90 && eventProgress < 100) {
              setActive([2, 3, 6, 5, 7, 1, 4]);
            } else if (eventProgress == 0) {
              setActive([]);
            }
          });
      };
      startScrollAnimation();
    }
    const clearScene = () => {
      if (scene) {
        scene.destroy(true);
      }
    };
    return clearScene;
  }, [scrollController, isMounted]);
  return (
    <PlusOneAttendeeWrap backgroundColor="yellow1" paddingTop={[0, 10, 12]}>
      <Box style={{ display: 'flex', justifyContent: 'flex-start', position: 'relative' }} ref={plusOneContainerRef} id="PlusOnes">
        <AvatarBoxPositionWrapper>
          {PlusOneAttendeeAvatar.map((avatar, index) => (
            <AvatarContainer
              key={index}
              isActive={active.includes(index + 1)}
              bottom={avatar.bottom}
              left={avatar.left}
              right={avatar.right}
              resBottom={avatar.resBottom}
              resLeft={avatar.resLeft}
              resRight={avatar.resRight}
              height={avatar.height}
              width={avatar.width}
              resHeight={avatar.resHeight}
            >
              <OuterBorder
                key={index}
                isActive={active.includes(index + 1)}
                height={avatar.borderHeight}
                width={avatar.borderWidth}
                borderResHeight={avatar.borderResHeight}
              />

              <AvatarWrap>
                <AvtarFront height={avatar.height} width={avatar.width} resHeight={avatar.resHeight}>
                  <AvtarFrontText>{avatar.content}</AvtarFrontText>
                </AvtarFront>
                <AvatarBack>
                  <AvatarBackImage>
                    <PlusOneNamesImage
                      alt={avatar.alt}
                      style={{ verticalAlign: 'bottom', borderRadius: '50%' }}
                      src={avatar.src}
                      height={avatar.sizeVariant}
                      width={avatar.sizeVariant}
                      resHeight={avatar.resHeight}
                      resWidth={avatar.resHeight}
                    />
                  </AvatarBackImage>
                </AvatarBack>
              </AvatarWrap>
            </AvatarContainer>
          ))}
        </AvatarBoxPositionWrapper>
      </Box>
    </PlusOneAttendeeWrap>
  );
};
